import { matchesAirror, NO_PERMISSION, NOT_FOUND } from '@air/errors';

/**
 * Deleted or out-of-reach agent chats are a stable 404/403 — retrying them only delays the URL
 * cleanup. Other failures still retry as a blip.
 */
export const isWorkspaceAgentSessionUnresolvableError = (error: unknown): boolean =>
  matchesAirror(error, NOT_FOUND) || matchesAirror(error, NO_PERMISSION);
